// extracted by mini-css-extract-plugin
export default {"sec1":"Andre_sec1__AJz0y","sec2":"Andre_sec2__JhSPq","sec3":"Andre_sec3__jrGw1","gallery":"Andre_gallery__XTw7q"};